<template>
    <order-timeline-box
            :title="__('general.received')"
            :message="__('general.channel') + ': '+ order.integration.name"
            :timestamp="order.created_at"
            :complete="isComplete"
            :spinner="isLoading"
            icon="fa-sign-in-alt"
    >
        <button class="btn btn-success" @click="$emit('transition', OrderState.Confirmed)">
            <i class="fas fa-check"/>
            {{ __('general.thing.to_accept', {thing: readableOrderType}) }}
        </button>
    </order-timeline-box>
</template>

<script>
import OrderTimelineBox from '@components/Orders/Timeline/OrderTimelineBox.vue';
import {OrderState} from '@composables/orderStates';

export default {
    components: {OrderTimelineBox},

    props: {
        order: Object,
    },

    computed: {
        OrderState() {
            return OrderState;
        },

        logsByState(){
            return this.order.logs_by_state;
        },

        isComplete() {
            return this.order.integration.code === 'AMZN'
                || this.order.integration.code === 'MFN'
                || this.logsByState.hasOwnProperty(OrderState.Confirmed)
                || this.logsByState.hasOwnProperty(OrderState.Cancelled)
                || this.logsByState.hasOwnProperty(OrderState.Rejected)
                || this.logsByState.hasOwnProperty(OrderState.Refunded)
                || this.logsByState.hasOwnProperty(OrderState.Send)
                || this.logsByState.hasOwnProperty(OrderState.ReadyForPickup)
                || this.logsByState.hasOwnProperty(OrderState.PickedUp);
        },

        isLoading() {
            return (this.order.integration.code === 'AMZN' || this.order.integration.code === 'MFN')
                && this.order.state === OrderState.Pending;
        },

        readableOrderType() {
            return this.order.type === 'reservation' ? __('general.reservation') : __('general.order');
        },
    },
};
</script>
